export type SessionsKeysListArgs = {
  tillId: string;
  end?: number;
  start?: number;
};

export type SessionsKeysDetailArgs = {
  tillId: string;
  sessionId: string;
  options?: { expand?: "profiles" };
};

export const sessionsKeys = {
  all: ["sessions"] as const,
  lists: () => [...sessionsKeys.all, "list"] as const,
  list: ({ tillId, end, start }: SessionsKeysListArgs) =>
    [...sessionsKeys.lists(), tillId, { end, start }] as const,
  details: () => [...sessionsKeys.all, "detail"] as const,
  detail: ({ tillId, sessionId, options }: SessionsKeysDetailArgs) =>
    options
      ? ([...sessionsKeys.details(), tillId, sessionId, options] as const)
      : ([...sessionsKeys.details(), tillId, sessionId] as const)
};
